/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandOpera = createReactComponent("brand-opera", "IconBrandOpera", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 12m-3 0a3 5 0 1 0 6 0a3 5 0 1 0 -6 0", key: "svg-1" }]
]);

export { IconBrandOpera as default };
//# sourceMappingURL=IconBrandOpera.js.map
